import styled from 'styled-components'

export const HistoryBtn = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 50%;
  height: 50px;
  border-radius: 50px 50px 0 0;
  background: rgb(255 193 7 / 88%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-50%);
  z-index: 9999;
  transition: opacity 0.3s ease, visibility 0.3s ease;

  &.show {
    opacity: 1;
    visibility: visible;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      color: #fff;
      font-weight: 600;
    }
  }
`
